import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

const ArrowRight: FC<SvgIconProps> = (props) => (
  <SvgIcon fill="none" height={62} viewBox="0 0 62 62" width={62} {...props}>
    <circle cx={31} cy={31} fill="#fff" r={31} />
    <path
      d="M9.54 31a21.462 21.462 0 1042.923 0 21.462 21.462 0 00-42.924 0zm25.452-7.919l6.138 6.439c.091.093.164.202.215.322.091.1.164.217.215.343a2.017 2.017 0 010 1.631 2.146 2.146 0 01-.451.708l-6.439 6.439a2.155 2.155 0 11-3.047-3.048l2.79-2.768H22.416a2.147 2.147 0 010-4.293h12.147l-2.683-2.811a2.148 2.148 0 013.112-2.962z"
      fill="#D82662"
    />
  </SvgIcon>
);

export default ArrowRight;
